export var EXTENSION_PADDING = 8;
export var BODIED_EXT_PADDING = EXTENSION_PADDING * 2;
export var BODIED_EXT_MBE_MARGIN_TOP = 12;